<template>
    <div class="cst-survey-card-question">
        <h2>{{ $t('selectorTextThanks') }} <br />
           {{ $t('selectorTextSelect') }}</h2>
        <ul>
            <li class="cst-survey-module" :key="module.id" v-for="module in modules" @click="handleSelection(module.id)">
                <check-box :moduleId="module.id" :selectedModules="selectedModules"></check-box>
                <input class="cst-base-input" type="checkbox" :id="module.id" :value="module.id" v-model="selectedModules" />
                <label :for="module.id"> {{ module.name }}</label>
            </li>
        </ul>
        <button @click="next">{{ $t("btnNext") }}</button>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import CheckBox from './CheckBox'

    export default {
      props: ['content'],
      methods: {
        next: function () {
          eventHub.$emit('card-next')
        },
        pushData: function () {
          return new Promise((resolve, reject) => {
            if (this.content.hasExternalQuestions) {
              this.$store.dispatch('loadExtendedSurvey', { 'modules': this.selectedModules }).then(() => resolve())
            } else {
              resolve()
            }
          })
        },
        handleSelection: function (moduleId) {
          let moduleIndex = this.selectedModules.indexOf(parseInt(moduleId))
          if (moduleIndex !== -1) {
            this.selectedModules.splice(moduleIndex, 1)
          } else {
            this.selectedModules.push(parseInt(moduleId))
          }
        }
      },
      computed: {
        selectedModules: {
          get () {
            return this.$store.state.selectedModules
          },
          set (value) {
            this.$store.commit('setSelectedModules', value.map(function (e) { return parseInt(e) }))
          }
        },
        modules: function () {
          return this.$store.state.decks[0].modules
        }
      },

      created: function () {
        eventHub.$emit('set-title', this.$t('selectorTitle'))
        eventHub.$emit('pre-change-register', this.pushData)
      },
      components: {
        CheckBox
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    h2 {
        text-align: center;
        margin: 0;
        padding: 0;
    }
    button {
        background-color: @main-button-color;
        .cst-survey-btn;
        display: block;
        margin: auto;
    }

    ul {
        .option-list;
        margin-bottom: 1em;
    }
    .cst-base-input {
        display: none;
    }
    li.cst-survey-module {
        display: flex;
    }
    label {
        margin-left: 0.5em;
    }
    h2 {
      margin-bottom: 1em;
      border: none;
    }

    .cst-survey-card-question {
      width: 100%;
    }
    
</style>




// WEBPACK FOOTER //
// src/components/CardQuestionSelector.vue